"use client";

import { Box, Flex, Heading } from "@chakra-ui/react";
import { HoverCard, HoverCardProps } from "@ui/components/hover-card";
import { SectionTemplate } from "components/individuals/blocks";
import { IconCarousel } from "./icon-carousel";
import { useState } from "react";

export interface FeatureCardsViewProps {
  id: string;
  title: string;
  subtitle: string;
  textColor: string;
  bg: string;
  infoCards: HoverCardProps[];
}

export const FeatureCardsView = ({
  id,
  title,
  subtitle,
  textColor,
  bg,
  infoCards,
}: FeatureCardsViewProps) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeCard = infoCards[activeIndex];

  return (
    <SectionTemplate id={id} bg={bg} color={textColor}>
      <Heading
        as={"h1"}
        fontSize={{
          base: 26,
          md: 34,
          lg: 38,
          xl: 45,
        }}
        lineHeight={1.2}
        fontWeight={"bold"}
        mb={{
          base: 8,
          lg: 12,
        }}
        textAlign={"left"}
        w={{
          lg: "80%",
        }}
      >
        {title}
      </Heading>
      <Heading
        as={"h2"}
        fontSize={{
          base: 16,
          md: 20,
          xl: 22,
        }}
        fontWeight={"semibold"}
        mb={{
          base: 0,
          lg: 14,
        }}
        textAlign={"left"}
        w={{
          lg: "85%",
        }}
      >
        {subtitle}
      </Heading>
      <Flex
        mt={{
          base: 8,
        }}
        gap={10}
        flexDir={"column"}
      >
        <IconCarousel
          items={infoCards.map((card) => ({
            id: card.id,
            label: card.label,
            icon: card.icon,
          }))}
          activeIndex={activeIndex}
          onActiveChange={setActiveIndex}
        />
        <Flex
          flexDir={{
            base: "column",
            md: "row",
          }}
          rowGap={8}
        >
          <Box
            w={{
              md: "50%",
              xl: "40%",
            }}
          >
            <HoverCard {...activeCard} textColor={textColor} bg="white" />
          </Box>
          <Box
            w={{
              md: "50%",
              xl: "60%",
            }}
          >
            <video
              autoPlay
              muted
              loop
              playsInline
              aria-hidden="true"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            >
              <source
                src={
                  "https://us-east-1.graphassets.com/Asv42xiViTEaNUIJrjCFhz/cmtwd76ezcx9p06k3hrp4voub"
                }
                type="video/mp4"
              />
            </video>
          </Box>
        </Flex>
      </Flex>
    </SectionTemplate>
  );
};

export default FeatureCardsView;
